var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24414 13.6191L11.332 6.82812C11.5547 6.64258 11.7773 6.53125 12 6.53125C12.2227 6.53125 12.4082 6.60547 12.5938 6.75391L19.6816 13.5449C20.0527 13.916 20.0527 14.4727 19.7188 14.8066C19.3848 15.1777 18.8281 15.1777 18.457 14.8438L12 8.68359L5.46875 14.918C5.13477 15.252 4.54102 15.252 4.20703 14.8809C3.87305 14.5098 3.87305 13.9531 4.24414 13.6191Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.b77d8bb982bcf33570e7fbea61d0814c.svg";
export { ForwardRef as ReactComponent };